import { intersection } from 'lodash';
import { store } from '@app/helpers/store';

class RoutingService {
    hasRoutePermission(url: string): boolean {
        // normalize url
        if (!url) {
            return true;
        }
        let normalizedUrl = url.toLowerCase();
        if (!normalizedUrl.startsWith('/')) {
            normalizedUrl = '/' + normalizedUrl;
        }

        if (
            normalizedUrl.startsWith('/apps') ||
            normalizedUrl.startsWith('/profile') ||
            normalizedUrl.startsWith('/help') ||
            normalizedUrl.startsWith('/onboard') ||
            normalizedUrl.startsWith('/trust') ||
            normalizedUrl.startsWith('/signout') ||
            normalizedUrl.startsWith('/authorize') ||
            normalizedUrl.startsWith('/profile/testmfa') ||
            normalizedUrl.startsWith('/license/billing') ||
            normalizedUrl.startsWith('/signin') ||
            normalizedUrl === '/passwords' ||
            normalizedUrl.startsWith('/passwords/details') ||
            normalizedUrl === '/kaseyaone' ||
            normalizedUrl.startsWith('/integrations') ||
            normalizedUrl.startsWith('/password-manager')
        ) {
            return true;
        }

        const currentUser = store.getState().signIn.currentUser;
        const shellConfigs = store.getState().basic.shellConfig;

        let permitted = false;
        if (normalizedUrl.startsWith('/passwordserver') || normalizedUrl.startsWith('/password-manager')) {
            let vaultPermissions = this.resolveAuthorizedVaultMapping(normalizedUrl, currentUser, shellConfigs);
            permitted = intersection(vaultPermissions, currentUser.vaultPermNames).length > 0;
        }

        // find the app that corresponds to url
        let permissions = this.resolveAuthorizedMapping(normalizedUrl, currentUser, shellConfigs);
        if (intersection(permissions, currentUser.permissions).length > 0) {
            permitted = true;
        }
        return permitted;
    }

    private asLaunchUriPermissionMap(currentUser: any, shellConfigs: any) {
        let map: { [permKey: string]: string[] } = {};
        if (shellConfigs && shellConfigs.apps && shellConfigs.apps.length && currentUser && currentUser.permissions && currentUser.permissions.length) {
            shellConfigs.apps.forEach(function (app: any) {
                if (app.launchUri && app.permissions && app.permissions.length) {
                    map[app.launchUri] = app.permissions;
                }

                if (app.navLinks && app.navLinks.length) {
                    app.navLinks.forEach(function (navLink: any) {
                        if (navLink.resource && navLink.permissions && navLink.permissions.length) {
                            map[navLink.resource] = navLink.permissions;
                        }
                    });
                }
            });
        }
        return map;
    }

    private resolveAuthorizedMapping(url: string, currentUser: any, shellConfigs: any): string[] {
        let map = this.asLaunchUriPermissionMap(currentUser, shellConfigs);
        let mappedPermission = new Array<string>();
        Object.keys(map).forEach(function (key) {
            if (url && url.startsWith(key)) {
                mappedPermission = map[key];
            }
        });

        return mappedPermission;
    }

    private asLaunchUriVaultPermissionMap(currentUser: any, shellConfigs: any) {
        let map: { [permKey: string]: string[] } = {};

        if (shellConfigs && shellConfigs.apps && shellConfigs.apps.length && currentUser && currentUser.vaultPermNames && currentUser.vaultPermNames.length) {
            shellConfigs.apps.forEach(function (app: any) {
                if (app.launchUri && app.permissions && app.permissions.length) {
                    map[app.launchUri] = app.permissions;
                }

                if (app.navLinks && app.navLinks.length) {
                    app.navLinks.forEach(function (navLink: any) {
                        if (navLink.resource && navLink.vaultPermissions && navLink.vaultPermissions.length && navLink.permissions && navLink.permissions.length) {
                            map[navLink.resource] = navLink.permissions.concat(navLink.vaultPermissions);
                        }
                    });
                }
            });
        }
        return map;
    }

    // calculate the user permissions based on vault memberships
    private resolveAuthorizedVaultMapping(url: string, currentUser: any, shellConfigs: any) {
        let map = this.asLaunchUriVaultPermissionMap(currentUser, shellConfigs);
        let mappedPermission = new Array<string>();
        Object.keys(map).forEach(function (key) {
            if (url && url.startsWith(key)) {
                mappedPermission = map[key];
            }
        });
        return mappedPermission;
    }
}

export const routingService = new RoutingService();
